import React from "react";
import "./Header.css";
import SearchProduct from "../SearchProduct/SearchProduct";

const TransferSearch = () => {
  return (
    <div className="pattern-bg2">
      <div className="container-searchh pattern-bg2 container a-container a-padding">
        <div className="TitleWelcome">
          <h1 className="title">
            <span className="text-pent">Learn&nbsp;</span>
            your Domain value
            <span className="text-pent">&nbsp;in Seconds</span>
          </h1>
          <p className="!w-full title-sub !normal-case paragraph !ml-0">
            Discover the true value of your domain with our instant appraisal
            tool. Enter the name and get accurate, industry-based results. Make
            informed decisions about your investment. Try it now!
          </p>
        </div>

        <SearchProduct />
      </div>
    </div>
  );
};

export default TransferSearch;
